/* ============================================================
   SINGSPACE ADMIN - GROUPE DE CHAMPS PARAMÈTRES (Pro Max)
   ============================================================ */

import { Label } from '@/components/ui/label';

interface FieldGroupProps {
  label: string;
  hint?: string;
  children: React.ReactNode;
}

export function FieldGroup({ label, hint, children }: FieldGroupProps) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-16 py-10 border-b border-gray-50 last:border-none group hover:bg-slate-50/20 transition-colors px-6 -mx-6 rounded-2xl">
      <div className="lg:col-span-4 space-y-2">
        <Label className="text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-900 block">
          {label}
        </Label>
        {hint && (
          <p className="text-[11px] font-semibold text-slate-500 leading-relaxed">
            {hint}
          </p>
        )}
      </div>
      <div className="lg:col-span-8 flex items-center">
        <div className="w-full">
          {children}
        </div>
      </div>
    </div>
  );
}
